import {Component, Input, SimpleChanges, OnChanges} from '@angular/core';

@Component({
  selector: "GridToggle",
  templateUrl: './gridtoggle.component.html',
  styleUrls: ['./gridtoggle.component.scss'],
})
export class GridToggle implements OnChanges {

  @Input() onChange: any;
  @Input() icon: string;
  @Input() active: string;
  @Input() selected: string = "2";

  constructor() {
    this.changeToggle = this.changeToggle.bind(this);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selected) {
      this.selected = changes.selected.currentValue;
    }
  }

  changeToggle(value) {
    this.selected = value;
    this.onChange(value);
  }
}
